import React, { useContext, useState, useEffect } from 'react';
import ClubListItem from './ClubListItem/ClubListItem';
import Styles from './ClubList.module.scss';
import { clubsContext } from '../../context/clubsContext';
import { LocalizationContext } from '../../context/localizationContext';
import { notificationContext } from '../../context/notificationContext';
import ClubListGroup from './ClubListGroup/ClubListGroup';
import APIClient from '../../helpers/APIClient';
import keys from '../../keys.json';
import Checkbox from '../Checkbox/Checkbox';

const ClubList = (props) => {
  const { isTileView, registered } = props;
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { userClubs, searchedClubs, selectedClubs } = state;
  const [clubList, setClubList] = useState(
    registered || isTileView ? userClubs : searchedClubs,
  );
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { registerNewClub, notification } = localizationState.localization;
  const [registeringClubs, setRegisteringClubs] = useState(false);
  const [selectedAll, setSelectedAll] = useState('CHECKED');
  const [unregisteredSearchedClubs, setUnregisteredSearchedClubs] = useState(
    [],
  );
  const { notificationDispatch } = useContext(notificationContext);
  const { linkKeys } = keys;

  const updateSelectedClubsList = (clubObj, subscribe) => {
    if (clubObj) {
      if (subscribe) {
        dispatch({
          type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
          searchedClubs,
          selectedClubs: [...selectedClubs, clubObj],
        });
      } else {
        dispatch({
          type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
          searchedClubs,
          selectedClubs: selectedClubs.filter(
            (item) => (item.club !== clubObj.club
                && item.serial_number === clubObj.serial_number
                && item.serial_id === clubObj.serial_id)
              || (item.serial_number !== clubObj.serial_number
                && item.serial_id === clubObj.serial_id),
          ),
        });
      }
    }
  };

  const handleCancelClick = () => {
    dispatch({
      type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
      searchedClubs: null,
      selectedClubs: [],
    });
  };

  const handleRegisterClick = () => {
    if (selectedClubs?.length) {
      setRegisteringClubs(true);
      const allRegisterClubsObj = {};
      selectedClubs.forEach((clubs) => {
        if (!allRegisterClubsObj[clubs.serial_id]) {
          allRegisterClubsObj[clubs.serial_id] = [];
        }
        allRegisterClubsObj[clubs.serial_id].push({
          clubs: [clubs.club],
          serial_number: clubs.serial_number,
        });
      });
      const promises = [];
      const serialList = [];
      Object.entries(allRegisterClubsObj).forEach(([serialId, data]) => {
        serialList.push(data[0].serial_number);
        const clubsArray = data.length > 1
          ? data.map((clubData) => {
            return clubData.clubs[0];
          })
          : data[0].clubs;
        const registerClubsObj = {
          serial_number: data[0].serial_number,
          serial_id: serialId,
          clubs: clubsArray,
        };
        const clubAddPromise = new Promise((resolve, reject) => {
          APIClient.registerClub(registerClubsObj, (registerStatus) => {
            if (registerStatus === 200) {
              resolve(true);
            }
            resolve(false);
          });
        });
        promises.push(clubAddPromise);
      });
      Promise.all(promises)
        .then((response) => {
          let passed = true;
          response.forEach((res) => {
            if (!res) {
              passed = false;
            }
          });
          if (passed) {
            const notificationReplace = notification?.addedClubs?.replace(
              '{club_count}',
              selectedClubs?.length,
            );
            notificationDispatch({
              type: 'SET_NOTIFICATION',
              isOpen: true,
              message: notificationReplace,
              icon: 'checkmark',
              addedClubSerial: serialList,
            });
            dispatch({
              type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
              searchedClubs: null,
              selectedClubs: [],
            });
            APIClient.getAllSerials((status, resp) => {
              if (status === 200) {
                dispatch({ type: 'SET_USER_CLUBS', clubs: resp.data });
                dispatch({ type: 'SET_LINK_KEY', key: linkKeys?.myClubs });
              } else {
                notificationDispatch({
                  type: 'SET_NOTIFICATION',
                  isOpen: true,
                  message: notification?.getClubsError,
                  icon: 'error',
                });
              }
            });
          } else {
            notificationDispatch({
              type: 'SET_NOTIFICATION',
              isOpen: true,
              message: notification?.addClubError,
              icon: 'error',
            });
          }
          setRegisteringClubs(false);
        })
        .catch(() => {
          throw new Error();
        });
    }
  };

  const getClubCountForSerial = (text) => {
    let message = '';
    if (text && searchedClubs?.length) {
      const searchedSerials = searchedClubs.map((club) => {
        return club.serial_number;
      });
      const searchedSerialsNoDuplicates = [...new Set(searchedSerials)];

      if (searchedSerialsNoDuplicates.length === 1) {
        message = text
          .replace('"{club_count_placeholder}"', searchedClubs.length)
          .replace('{serial_placeholder}', searchedSerialsNoDuplicates[0]);
      } else if (searchedSerialsNoDuplicates.length === 2) {
        message = text
          .replace('"{club_count_placeholder}"', searchedClubs.length)
          .replace(
            '{serial_placeholder}',
            `${searchedSerialsNoDuplicates[0]}"
      and "${searchedSerialsNoDuplicates[0]}`,
          );
      } else {
        message = '';
      }
    }
    return message;
  };

  const selectAll = () => {
    if (selectedAll === 'CHECKED') {
      dispatch({
        type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
        searchedClubs,
        selectedClubs: [],
      });
      setSelectedAll('UNCHECKED');
    } else if (selectedAll === 'UNCHECKED' || selectedAll === 'INDETERMINATE') {
      const unregisteredClubs = searchedClubs.filter(
        (club) => !club.registered,
      );
      dispatch({
        type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
        searchedClubs,
        selectedClubs: [...unregisteredClubs],
      });
      setSelectedAll('CHECKED');
    } else {
      setSelectedAll('CHECKED');
    }
  };

  useEffect(() => {
    if (registered || isTileView) {
      setClubList(userClubs);
    }
  }, [userClubs]);

  useEffect(() => {
    const unregisteredClubs = searchedClubs?.filter((club) => !club.registered);
    if (unregisteredClubs?.length) {
      setUnregisteredSearchedClubs(unregisteredClubs);
      dispatch({
        type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
        searchedClubs,
        selectedClubs: unregisteredClubs,
      });
    }
  }, [searchedClubs]);

  useEffect(() => {
    if (
      !isTileView
      && selectedClubs?.length > 0
      && unregisteredSearchedClubs?.length > 0
      && selectedClubs?.length === unregisteredSearchedClubs?.length
    ) {
      setSelectedAll('CHECKED');
    } else if (
      !isTileView
      && selectedClubs?.length > 0
      && unregisteredSearchedClubs?.length > 0
      && selectedClubs?.length !== unregisteredSearchedClubs?.length
    ) {
      setSelectedAll('INDETERMINATE');
    } else {
      setSelectedAll('UNCHECKED');
    }
  }, [selectedClubs, unregisteredSearchedClubs]);

  return (
    <div
      className={`${Styles.clubListContainer}
    ${isTileView && Styles.tileView}
    ${registered ? Styles.registered : Styles.newClubs}
    `}
    >
      {!registered && !isTileView && searchedClubs?.length && (
        <>
          <div className={Styles.searchedSerialMessage}>
            {getClubCountForSerial(registerNewClub?.foundClubs)}
          </div>
          {registerNewClub?.foundClubsDisclaimer && (
            <div
              className={Styles.disclaimer}
              dangerouslySetInnerHTML={{
                __html: registerNewClub.foundClubsDisclaimer ?? '',
              }}
            ></div>
          )}
          <div className={Styles.selectAll}>
            <Checkbox
              isChecked={selectedAll === 'CHECKED'}
              selectAllCheckbox={true}
              selectedAll={selectedAll}
              selectedClubsList={selectedClubs}
              unregisteredSearchedClubs={unregisteredSearchedClubs}
              defaultChecked={true}
              onclick={selectAll}
            />{' '}
            Select All
          </div>
        </>
      )}
      {clubList?.length
        && clubList.map((club, i) => {
          return (
            <div
              key={i}
              className={
                isTileView
                  ? Styles.clubListItemTile
                  : `${Styles.clubListItem} ${
                    registered && Styles.clubItemShadow
                  }`
              }
            >
              {club.clubs ? (
                <>
                  <ClubListGroup
                    club={club}
                    registered={registered || isTileView}
                    updateSelectedClubsList={updateSelectedClubsList}
                    isTileView={isTileView}
                  />
                </>
              ) : (
                <>
                  <ClubListItem
                    club={club}
                    registered={registered || isTileView}
                    updateSelectedClubsList={updateSelectedClubsList}
                    isTileView={isTileView}
                    selectedAll={selectedAll}
                  />
                </>
              )}
            </div>
          );
        })}
      {!registered && !isTileView && (
        <div className={Styles.registerClubsFooter}>
          <div className={Styles.clubsSelected}>
            <div className={Styles.clubsSelectedNumber}>
              {selectedClubs?.length}
            </div>
            <div>{registerNewClub.numberOfClubsSeleced}</div>
          </div>
          <button
            type="button"
            className={Styles.cancelButton}
            onClick={handleCancelClick}
          >
            {registerNewClub.cancelBtnTxt}
          </button>
          <button
            type="button"
            className={Styles.registerButton}
            onClick={handleRegisterClick}
            disabled={!selectedClubs.length || registeringClubs}
          >
            {registerNewClub.registerBtnTxt}
          </button>
        </div>
      )}
    </div>
  );
};

export default ClubList;
